import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  styled,
  Tab,
  Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  addAward,
  assignAwardToEvent,
  getAllAwards,
  removeAward,
  uploadAwardImage,
} from "../../api/award.api.js";
import CreateAwardModal from "../../components/modals/createAward.modal.js";
import { useSnackbar } from "../../context/snackbar.context.js";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { getEvents } from "../../api/event.api.js";

const AdminAwardsPage = () => {
  const showSnackbar = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [awards, setAwards] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    getAllAwards().then((responseAwards) => {
      getEvents().then((responseEvents) => {
        setEvents(responseEvents.data);
        setAwards(responseAwards.data);
      });
    });
  }, [refresh]);

  const handleSubmit = (formData) => {
    addAward(formData)
      .then(() => {
        setRefresh((prev) => !prev);
        showSnackbar("Award created!", "success");
      })
      .catch(() => showSnackbar("Failed to create Award!", "error"));
  };

  const handleUpload = (id, file) => {
    uploadAwardImage(id, file)
      .then((e) => {
        showSnackbar("Award image uploaded!", "success");
      })
      .catch((error) => {
        showSnackbar("Failed to upload image!", "error");
      });
  };

  const handleRemove = (id) => {
    removeAward(id)
      .then(() => {
        setRefresh((prev) => !prev);
        showSnackbar("Award deleted!", "success");
      })
      .catch(() => showSnackbar("Failed to remove Award!", "error"));
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAssignEvent = (award, eventId) => {
    if (eventId === "") {
      eventId = undefined;
    }
    award.eventId = eventId;
    assignAwardToEvent(award)
      .then(() => {
        showSnackbar("Award assigned to event!", "success");
        setRefresh((prev) => !prev);
      })
      .catch(() => showSnackbar("Failed to assign Award to event!", "error"));
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Awards Administration
      </Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Award Name</TableCell>
              <TableCell>Assigned Event</TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {awards.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell>
                  <FormControl fullWidth>
                    <InputLabel id="select-event-label">Event</InputLabel>
                    <Select
                      labelId="select-event-label"
                      id="simple-event-select"
                      value={
                        row.eventId !== "" && row.eventId !== undefined
                          ? events.find((evnt) => evnt.id === row.eventId).id
                          : ""
                      }
                      label="Event"
                      onChange={(change) =>
                        handleAssignEvent(row, change.target.value)
                      }
                    >
                      <MenuItem key={"noEvent"} value={""}>
                        No Event
                      </MenuItem>
                      {events.map((event) => (
                        <MenuItem key={event.id} value={event.id}>
                          {event.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  {row.imageFileName && (
                    <Box
                      component="img"
                      sx={{
                        height: 50,
                        width: 50,
                        maxHeight: 50,
                        maxWidth: 50,
                      }}
                      alt={row.name}
                      src={`/static/images/${row.imageFileName}`}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Stack spacing={1} direction="row">
                    <Button
                      component="label"
                      role={undefined}
                      variant="contained"
                      tabIndex={-1}
                      startIcon={<FileUploadIcon />}
                    >
                      Upload Image
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(event) =>
                          handleUpload(row.id, event.target.files[0])
                        }
                      />
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => handleRemove(row.id)}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" onClick={handleOpenModal} sx={{ mt: 1 }}>
        Create Award
      </Button>

      <CreateAwardModal
        aria-modal
        open={openModal}
        handleClose={handleCloseModal}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default AdminAwardsPage;
